import { sortBy, uniqBy } from "lodash";
import { createSelector } from "reselect";
import { GlobalSearchFields } from "constants/globalSearch";
import { Settings } from "constants/settings";
import { getLoads } from "./root";
import { getSetting } from "./settings";

export const selectLoadsForAgGrid = createSelector([getLoads], loads =>
  Object.values(loads),
);

export const selectLoadsBuyerOptions = createSelector([getLoads], loads =>
  sortBy(
    uniqBy(
      (Object.values(loads) as Loads[])
        .filter(load => load.buyer?.id && load.buyer?.name)
        .map(load => ({
          label: load.buyer.name,
          value: {
            field: GlobalSearchFields.Buyer,
            value: load.buyer.id,
          },
        })),
      option => option.value.value,
    ),
    "label",
  ),
);

export const selectFilteredLoadsForAgGrid = createSelector(
  [getLoads, getSetting(Settings.loadsFilter)],
  (loads, filter) => {
    const loadsArray = Object.values(loads) as Loads[];

    // If no filter or filter is empty, return all loads
    if (!filter || Object.keys(filter).length === 0) {
      return loadsArray;
    }

    // Filter by each field in the filter object
    // Currently only buyer filtering is supported, but structure allows for extension
    return loadsArray.filter(load => {
      // Buyer filter
      const buyerIds = filter[GlobalSearchFields.Buyer];
      if (buyerIds && buyerIds.length > 0) {
        if (!load.buyer?.id || !buyerIds.includes(load.buyer.id)) {
          return false;
        }
      }

      // Future filter fields can be added here:
      // const vendorIds = filter[GlobalSearchFields.Vendor];
      // if (vendorIds && vendorIds.length > 0) {
      //   if (!load.vendor?.id || !vendorIds.includes(load.vendor.id)) {
      //     return false;
      //   }
      // }

      return true;
    });
  },
);
